/**
 * Estrutura de um anexo retornado pelo avatar
 */
export interface AnexoFinanceiro {
    id: string;
    customId: string | null;
    key: string;
    name: string;
    status: "Uploaded" | "Processing" | "Failed"; // ajuste se houver mais
    size: number;
    uploadedAt: number; // timestamp
  }
  
export interface ListFilesResponse {
    hasMore: boolean;
    files: AnexoFinanceiro[];
}

// Tipagem detalhada do arquivo (pollUpload)
export interface AnexoFinanceiroDetalhado {
  fileData: {
    acl: string
    apiKey: string
    appId: string
    bucket: {
      id: number
      name: string
      region: string
      provider: string
      providerOwnerId: string
    }
    callbackSlug: string
    callbackUrl: string
    customId: string | null
    fileKey: string
    fileName: string
    fileSize: number
    fileType: string
    fileUrl: string   
    metadata: string
    ufsUrl: string
  }
  status: string
}

export interface AnexoFinanceiroIdentificador {
  filial: string
  fornecedor: string
  loja: string
  cod: string
}
